import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const LoomAuthTokenQuery: GraphQLTaggedNode = graphql`
	query LoomAuthTokenQuery {
		loomToken {
			token
		}
	}
`;
